import {useInfiniteQuery} from 'react-query';
import getMyAccess from '.';
import useInfiniteScroll from '../../../utilities/hooks/useInfiniteScroll';

const useGetMyAccess = () => {
  const {
    data: rawData,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useInfiniteQuery(
    ['farm-list'],
    async ({pageParam = 1}) => getMyAccess(pageParam),
    {
      getNextPageParam: (lastPage, allPages) => {
        if (!lastPage.next) return undefined;
        return allPages.length + 1;
      },
    },
  );

  const data = rawData?.pages.flatMap(page => page.results);

  const loaderRef = useInfiniteScroll({
    isLoading,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
  });

  return {
    data,
    isLoading,
    loaderRef,
    isFetchingNextPage,
  };
};

export default useGetMyAccess;
